import { PrometheusQuery } from "./PrometheusQuery";

export class InferenceRequestFailure extends PrometheusQuery {
  protected _id: string = "calculated:edge_inference_request_failure_total";

  public override getPossibleValues() {
    return [
      { id: "face_detection_f", color: "#0000FF" },
      { id: "helmet_classification_f", color: "#FF0000" },
      { id: "licence_plate_detection_f", color: "#7F00FF" },
      { id: "person_detection_f", color: "#000080" },
      { id: "person_reid_f", color: "#FFA500" },
      { id: "plate_recognizer_detection_f", color: "#008000" },
      { id: "pose_estimation_f", color: "#000000" },
      { id: "vehicle_detection_f", color: "#808080" }
    ]
  };

  public override getRefinedData() {
    const refinedData = [];

    if (this.isEmpty()) return [];

    for (let i = 0; i < this._queryData.data.result[0].values.length; i += 1) {

      const values: number[] = [];

      for (let j = 0; j < 8; j += 1) {
        try {
          values.push(Math.floor(+this._queryData.data.result[j]?.values[i][1]))
        } catch (e) {
          values.push(0)
        }
      }

      refinedData.push({
        date: this.formatDate(this._queryData.data.result[0].values[i][0]),
        "face_detection_f": values[0],
        "helmet_classification_f": values[1],
        "licence_plate_detection_f": values[2],
        "person_detection_f": values[3],
        "person_reid_f": values[4],
        "plate_recognizer_detection_f": values[5],
        "pose_estimation_f": values[6],
        "vehicle_detection_f": values[7],
      })
    }

    return refinedData;
  }

  public override getDomain() {
    if (this.isEmpty()) return [0, 100]
    return undefined;
  }

  public override getMiddleValue() {
    if (this.isEmpty()) return 50;
    return undefined;
  }

  public override getValueLabel() {
    return "";
  }
}